module.exports = __webpack_public_path__ + "static/img/banner.80f7779.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Conference/banner.png
// module id = RC0g
// module chunks = 1